module.exports = __webpack_public_path__ + "static/img/doora.d775555a.png";